export default function getErrorMessage(error: unknown): string {
    if (error && typeof error === 'object') {
        const serverMessage = (error as { response?: { data?: { message?: unknown } } }).response?.data?.message;
        if (typeof serverMessage === 'string' && serverMessage) {
            return serverMessage;
        }
    }

    if (typeof error === 'string' && error) {
        return error;
    }

    if (error instanceof Error && error.message) {
        return error.message;
    }

    return '';
}
